<!--
 * @Author: Zj
 * @Date: 2022-01-14 14:45:29
 * @LastEditTime: 2022-01-25 15:09:11
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp_cloud_app\src\views\medical-edu\case\detail.vue
-->
<template>
  <div class="caseDetail">
    <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div>
            <span class="name">{{ caseDetail.patientName }}</span>
            <span class="sex">{{ caseDetail.patientGender }}</span>
            <span class="age">{{ caseDetail.patientAge }}</span>
          </div>
        </template>
        <div class="content">
          <div class="main" v-for='(item,index) in formData' :key='index'>
             {{item.name}}:{{item.value}}
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <graphicrecord :editstatus='editstatus' :baseInfo='baseInfo' ref="graphicrecord"></graphicrecord>
  </div>
</template>
<script>
import graphicrecord from '../../../components/business/mdt-consult/graphic-record.vue';
export default {
  data () {
    return {
      activeNames: ['2'],
      caseDetail: {},
      formData: [],
      baseInfo: {},
      editstatus: false
    };
  },
  created () {
    this.caseDetail = JSON.parse(window.localStorage.getItem('tempData'));
    this.getCaseInformation(this.caseDetail.ehrId);
  },
  methods: {
    getCaseInformation (ehrId) {
      this.$axios
        .post('api/ehr/template/information', {
          data: {
            checkId: 0,
            ehrId: ehrId,
            templateId: -3
          },
          version: this.$version
        })
        .then((res) => {
          if (res.data) {
            var data = {
              businessId: 22222222,
              caseId: this.caseDetail.caseId,
              caseLocation: 2,
              ehrId: this.caseDetail.ehrId,
              moduleId: this.$route.query.moduleId,
              platformId: this.$store.state.userInfo.platformId
            };
            this.baseInfo = data;
            this.formData = res.data.list;
            setTimeout(() => {
              this.$refs.graphicrecord.getcheckinit();
            }, 300);
          }
        });
    }
  },
  components: {
    graphicrecord
  }
};
</script>
<style lang='scss' scope>
.content{
  word-break: break-all;
}
.main {
  font-size: 14px;
  color: #333;
  margin-top: 8px;
}
.name {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.sex {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  padding: 0 16px;
}
.age {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
}
</style>
